<template>
  <div>
    <Menu />

    <div v-if="loading">
      <center><div class="spinner"></div></center>
      <h2 class="text-center">Loading development</h2>
    </div>

    <div v-if="!loading && !developmentFound">
      <div class="container py-5 text-center">
        <h1>Development not found</h1>
        <p>The requested development could not be found.</p>
        <a href="/developments" class="btn btn-primary">Back to developments</a>
      </div>
    </div>

    <div v-if="!loading && developmentFound">
      <section>
        <div id="banner" class="mt-5 mb-3">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-12">
                <div class="banner-section porfolio-banner porfolio-banner6">
                  <div class="row g-0">
                    <div class="col-lg-4 col-md-5 align-self-center order-1 pe-2">
                      <h4>
                        {{ development.title }}
                        <span>{{ development.ref_id }}</span>
                      </h4>

                      <div class="underLineBorder"></div>

                      <div class="priceTag pb-3" v-if="hasPriceRange">
                        {{ formatCurrency(development.low_price) }}
                        -
                        {{ formatCurrency(development.high_price) }}
                      </div>

                      <div class="priceTag pb-3" v-else>
                        POA
                      </div>
                    </div>

                    <div class="col-lg-8 col-md-6 col-sm-7 order-md-2 order-sm-4 order-2">
                      <button
                        type="button"
                        class="btn"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasBottom"
                        aria-controls="offcanvasBottom"
                        style="padding: 0; border: none; background: transparent; width: 100%; height: auto;"
                      >
                        <img
                          :src="getImageUrl(development.cover_image)"
                          class="mw-100 banner-image"
                          style="border-top-left-radius: 30px;"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasBottom"
          aria-controls="offcanvasBottom"
          class="btn w-100 gallery-button"
        >
          <i class="bi bi-images"></i> View Gallery
        </button>


        <!-- Gallery Offcanvas -->
        <div
          class="offcanvas offcanvas-bottom"
          id="offcanvasBottom"
          tabindex="-1"
          aria-labelledby="offcanvasBottomLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">
              GALLERY VIEW
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>

          <div class="offcanvas-body">
            <div class="photo-album" v-if="galleryImages.length">
              <div
                class="photo-row"
                v-for="(image, index) in galleryImages"
                :key="index"
              >
                <div class="photo-item">
                  <a :href="image" data-lightbox="development-gallery">
                    <img :src="image" class="img-fluid" />
                  </a>
                </div>
              </div>
            </div>

            <div v-else class="container text-center py-5">
              <h3>No gallery images available</h3>
            </div>
          </div>
        </div>

        <!-- Main Gallery Preview -->
        <div class="container-fluid mt-4" v-if="galleryImages.length">
          <div class="row g-2 px-lg-5">
            <div class="col-lg-6" v-if="galleryImages[0]">
              <button
                type="button"
                class="btn gallery-preview-btn"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasBottom"
                aria-controls="offcanvasBottom"
              >
                <img :src="galleryImages[0]" class="w-100 main-gallery-image" />
              </button>
            </div>

            <div class="col-lg-6">
              <div class="row g-2">
                <div
                  class="col-6"
                  v-for="(image, index) in galleryPreviewImages"
                  :key="index"
                >
                  <button
                    type="button"
                    class="btn gallery-preview-btn"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasBottom"
                    aria-controls="offcanvasBottom"
                  >
                    <img :src="image" class="w-100 small-gallery-image" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- About -->
        <div class="pt-lg-5">
          <div class="wrapper">
            <div class="container">
              <div class="row">
                <div class="col-12 mb-5">
                  <div class="switch-bg-lgrey p-sm-5 p-4 pb-5 about-block">
                    <h5 class="switch-ddblue mb-4">About this development</h5>
                    <p
                      v-for="(paragraph, index) in formattedDescription"
                      :key="index"
                    >
                      {{ paragraph }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center pb-5 mb-5">
                <div class="col-md-3 col-sm-6">
                  <div class="prop-details">
                    {{ formatCurrency(development.low_price) }}
                    <span>STARTING FROM</span>
                  </div>
                </div>

                <div class="col-md-3 col-sm-6" v-if="properties.length">
                  <div class="prop-details">
                    {{ properties.length }}
                    <span>PROPERTY TYPES</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Amenities / Activities -->
          <div class="wrapper">
            <div class="container">
              <div class="row mt-5">
                <div class="col-12 mt-4">
                  <ul class="nav nav-tabs temp6-tabs justify-content-center" id="developmentTabs" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="amenities-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#amenities-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="amenities-tab-pane"
                        aria-selected="true"
                      >
                        Amenities
                      </button>
                    </li>

                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="activities-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#activities-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="activities-tab-pane"
                        aria-selected="false"
                      >
                        Activities
                      </button>
                    </li>
                  </ul>

                  <div class="tab-content" id="developmentTabsContent">
                    <div
                      class="tab-pane fade show active p-lg-5 p-3"
                      id="amenities-tab-pane"
                      role="tabpanel"
                      aria-labelledby="amenities-tab"
                      tabindex="0"
                    >
                      <h5 class="switch-ddblue mb-4">Amenities</h5>
                      <p>{{ development.amenities }}</p>
                    </div>

                    <div
                      class="tab-pane fade p-lg-5 p-3"
                      id="activities-tab-pane"
                      role="tabpanel"
                      aria-labelledby="activities-tab"
                      tabindex="0"
                    >
                      <h5 class="switch-ddblue mb-4">Activities</h5>
                      <p>{{ development.activities }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Child Properties -->
          <div class="container pb-5 mb-5" v-if="properties.length">
            <div class="row pt-5">
              <div class="col-12 text-center mb-4">
                <h1>Available Properties</h1>
                <p>Explore available homes within this development.</p>
              </div>

              <div
                class="col-md-4 mt-4"
                v-for="(property, index) in properties"
                :key="index"
              >
                <div class="banner-section lifestyle-block switch-bg-lgrey p-3 h-100 bord-radius">
                  <div class="portfolio-thumbnail" v-if="property.image">
                    <button
                      v-if="getPropertyGallery(property).length"
                      type="button"
                      class="property-card-gallery-trigger"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#propertyGalleryOffcanvas"
                      aria-controls="propertyGalleryOffcanvas"
                      :aria-label="'View gallery for Property ' + (index + 1)"
                      @click="openPropertyGallery(property, index)"
                    >
                      <img
                        :src="getImageUrl(property.image)"
                        :alt="property.title || ('Property ' + (index + 1))"
                        class="w-100 force-height"
                      />
                      
                    </button>

                    <img
                      v-else
                      :src="getImageUrl(property.image)"
                      :alt="property.title || ('Property ' + (index + 1))"
                      class="w-100 force-height"
                    />

                    <div class="thumbnail-priceTag">
                      From {{ formatCurrency(property.from_price) }}
                    </div>
                  </div>

                  <div class="portfolio-thumbnail no-image" v-else>
                    <div class="thumbnail-priceTag">
                      From {{ formatCurrency(property.from_price) }}
                    </div>
                  </div>

                  <h4 class="text-start mt-3">
                    {{ property.title || ('Property ' + (index + 1)) }}
                  </h4>

                  <p>{{ property.description }}</p>

                  <button
                    v-if="getPropertyGallery(property).length"
                    type="button"
                    class="btn btn-primary property-gallery-button mb-3"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#propertyGalleryOffcanvas"
                    aria-controls="propertyGalleryOffcanvas"
                    @click="openPropertyGallery(property, index)"
                  >
                    <i class="bi bi-images"></i> View Gallery
                  </button>

                  <div class="row text-center mt-3">
                    <div class="col-6" v-if="property.erf_size">
                      <div class="mini-detail">
                        {{ property.erf_size }}
                        <span>ERF SIZE</span>
                      </div>
                    </div>

                    <div class="col-6" v-if="property.floor_size">
                      <div class="mini-detail">
                        {{ property.floor_size }}
                        <span>FLOOR SIZE</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Property Gallery Offcanvas -->
          <div
            class="offcanvas offcanvas-bottom"
            id="propertyGalleryOffcanvas"
            tabindex="-1"
            aria-labelledby="propertyGalleryOffcanvasLabel"
          >
            <div class="offcanvas-header property-gallery-header">
              <div class="property-gallery-heading">
                <span class="property-gallery-eyebrow">Property gallery</span>

                <h2
                  class="offcanvas-title property-gallery-title"
                  id="propertyGalleryOffcanvasLabel"
                >
                  {{ selectedPropertyTitle }}
                </h2>

                <p
                  v-if="selectedPropertyDescription"
                  class="property-gallery-summary"
                >
                  {{ selectedPropertyDescription }}
                </p>

                <div class="property-gallery-meta">
                  <span v-if="selectedPropertyPrice" class="property-gallery-price">
                    From {{ formatCurrency(selectedPropertyPrice) }}
                  </span>

                  <span v-if="selectedPropertyGallery.length" class="property-gallery-count">
                    <i class="bi bi-images"></i>
                    {{ selectedPropertyGallery.length }}
                    {{ selectedPropertyGallery.length === 1 ? 'image' : 'images' }}
                  </span>
                </div>
              </div>

              <button
                type="button"
                class="btn-close property-gallery-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>

            <div class="offcanvas-body">
              <div class="photo-album" v-if="selectedPropertyGallery.length">
                <div
                  v-for="(row, rowIndex) in selectedPropertyGalleryRows"
                  :key="'property-gallery-row-' + rowIndex"
                  class="photo-row"
                  :class="row.type"
                >
                  <div
                    v-for="(image, imageIndex) in row.images"
                    :key="image.originalIndex"
                    class="photo-item"
                  >
                    <a
                      :href="image.url"
                      :data-lightbox="'property-gallery-' + selectedPropertyGalleryKey"
                      :data-title="selectedPropertyTitle"
                    >
                      <img
                        :src="image.url"
                        class="img-fluid"
                        :alt="selectedPropertyTitle + ' image ' + (image.originalIndex + 1)"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div v-else class="container text-center py-5">
                <h3>No property gallery images available</h3>
              </div>
            </div>
          </div>

          <!-- Contact -->
          <div class="container-fluid bg-light">
            <div class="row">
              <div class="col-12 text-center mt-3">
                <h1>CONTACT DETAILS</h1>
              </div>
            </div>

            <div class="row justify-content-center pt-5 pb-5">
              <div class="col-md-5 text-center">
                <h3 class="switch-blue mb-3">
                  <strong>{{ development.contact_name }}</strong>
                </h3>

                <p style="line-height: 28px;">
                  <a
                    v-if="development.contact_phone"
                    style="text-decoration: none;"
                    class="switch-blue"
                    :href="'tel:' + development.contact_phone"
                  >
                    <i class="bi bi-telephone-fill"></i>
                    {{ development.contact_phone }}
                  </a>
                  <br v-if="development.contact_phone" />

                  <a
                    v-if="development.contact_email"
                    style="text-decoration: none;"
                    class="switch-blue"
                    :href="'mailto:' + development.contact_email"
                  >
                    <i class="bi bi-envelope-fill"></i>
                    {{ development.contact_email }}
                  </a>
                  <br v-if="development.contact_email" />

                  <a
                    v-if="whatsappLink"
                    style="text-decoration: none;"
                    class="switch-blue"
                    :href="whatsappLink"
                    target="_blank"
                  >
                    <i class="bi bi-whatsapp"></i>
                    Whatsapp
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/home/Menu.vue'
import Footer from '@/components/home/Footer.vue'

export default {
  name: 'Development',

  components: {
    Menu,
    Footer
  },

  data() {
    return {
      loading: true,
      developmentFound: false,
      development: {},
      meta: {},
      allDevelopments: [],
      selectedPropertyGallery: [],
      selectedPropertyTitle: 'Property Gallery',
      selectedPropertyDescription: '',
      selectedPropertyPrice: '',
      selectedPropertyGalleryKey: 'property'
    }
  },

  created() {
    this.fetchDevelopment()
  },

  computed: {
    developmentId() {
      return this.$route.params.developmentId
    },

    hasPriceRange() {
      if (this.development.low_price && this.development.high_price) {
        return true
      }

      return false
    },

    properties() {
      if (this.development.properties && this.development.properties.length) {
        return this.development.properties
      }

      return []
    },

    galleryImages() {
      const images = []

      if (this.development.cover_image) {
        images.push(this.getImageUrl(this.development.cover_image))
      }

      if (this.development.image_gallery && this.development.image_gallery.length) {
        this.development.image_gallery.forEach((image) => {
          if (image.url) {
            const imageUrl = this.getImageUrl(image.url)

            if (images.indexOf(imageUrl) === -1) {
              images.push(imageUrl)
            }
          }
        })
      }

      return images
    },

    galleryPreviewImages() {
      return this.galleryImages.slice(1, 5)
    },

    selectedPropertyGalleryRows() {
      const rows = []
      const layoutPattern = [
        { count: 2, type: 'large' },
        { count: 3, type: 'small' },
        { count: 1, type: 'single' },
        { count: 3, type: 'small' },
        { count: 1, type: 'single' },
        { count: 3, type: 'small' }
      ]

      let imageIndex = 0
      let patternIndex = 0

      while (imageIndex < this.selectedPropertyGallery.length) {
        const layout = layoutPattern[patternIndex % layoutPattern.length]
        const rowImages = this.selectedPropertyGallery
          .slice(imageIndex, imageIndex + layout.count)
          .map((url, offset) => ({
            url,
            originalIndex: imageIndex + offset
          }))

        rows.push({
          type: rowImages.length === 1 ? 'single' : layout.type,
          images: rowImages
        })

        imageIndex += layout.count
        patternIndex += 1
      }

      return rows
    },

    formattedDescription() {
      if (!this.development.description) {
        return []
      }

      const rawDescription = String(this.development.description)
      const sentences = rawDescription.split('. ')
      const paragraphs = []

      for (let i = 0; i < sentences.length; i += 3) {
        const paragraph = sentences.slice(i, i + 3).join('. ')

        if (paragraph !== '') {
          if (!paragraph.endsWith('.')) {
            paragraphs.push(paragraph + '.')
          } else {
            paragraphs.push(paragraph)
          }
        }
      }

      return paragraphs
    },

    currentUrl() {
      return encodeURIComponent(window.location.href)
    },

    facebookShareLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
    },

    pinterestShareLink() {
      const title = encodeURIComponent(this.development.title || 'Luxury Development')
      const image = encodeURIComponent(this.getImageUrl(this.development.cover_image))

      return `http://pinterest.com/pin/create/bookmarklet/?media=${image}&url=${this.currentUrl}&is_video=false&description=${title}`
    },

    whatsappLink() {
      if (!this.development.contact_phone) {
        return ''
      }

      const currentUrl = window.location.href
      const cleanedNumber = this.development.contact_phone.replace(/\D/g, '')
      const countryCode = '27'
      const formattedNumber = cleanedNumber.startsWith(countryCode)
        ? cleanedNumber
        : countryCode + cleanedNumber

      return `https://wa.me/${formattedNumber}?text=Hello! I am interested in the development I found on your Portfolio website: ${currentUrl}`
    }
  },

  methods: {
    async fetchDevelopment() {
      this.loading = true
      this.developmentFound = false

      try {
        const response = await axios.get(
          this.$store.state.apiBaseUrl + 'fetch_all_developments.php',
          { headers: { Accept: 'application/json' } }
        )

        if (
          response.data &&
          response.data.success === true &&
          Array.isArray(response.data.developments)
        ) {
          this.allDevelopments = response.data.developments
          this.findCurrentDevelopment()
        }
      } catch (error) {
        console.log(error)
      }

      this.loading = false
    },

    findCurrentDevelopment() {
      let matched = null

      this.allDevelopments.forEach((item) => {
        const row = this.getDevelopmentRow(item)
        const meta = item.meta || {}

        if (!matched && row.ref_id === this.developmentId) {
          matched = {
            development: row,
            meta: meta
          }
        }

        if (!matched && meta.ref_id === this.developmentId) {
          matched = {
            development: row,
            meta: meta
          }
        }

        if (!matched && this.slugify(row.title) === this.developmentId) {
          matched = {
            development: row,
            meta: meta
          }
        }
      })

      if (matched) {
        this.development = matched.development
        this.meta = matched.meta
        this.developmentFound = true
        this.setPageMeta()
      }
    },

    getDevelopmentRow(item) {
      if (
        item &&
        item.development &&
        item.development.data &&
        item.development.data.development &&
        item.development.data.development[0]
      ) {
        return item.development.data.development[0]
      }

      return {}
    },

    getImageUrl(path) {
      if (!path) {
        return this.$store.state.imageBaseUrl + 'developments-images/placeholder.jpg'
      }

      if (path.indexOf('http') === 0) {
        return path
      }

      return this.$store.state.imageBaseUrl.replace(/\/$/, '') + '/' + path.replace(/^\//, '')
    },

    getPropertyGallery(property) {
      if (!property) {
        return []
      }

      const images = []

      if (Array.isArray(property.image_gallery)) {
        property.image_gallery.forEach((image) => {
          let path = ''

          if (typeof image === 'string') {
            path = image
          } else if (image && image.url) {
            path = image.url
          } else if (image && image.image) {
            path = image.image
          }

          if (path) {
            const imageUrl = this.getImageUrl(path)

            if (images.indexOf(imageUrl) === -1) {
              images.push(imageUrl)
            }
          }
        })
      }

      if (property.image) {
        const coverImage = this.getImageUrl(property.image)

        if (images.indexOf(coverImage) === -1) {
          images.unshift(coverImage)
        }
      }

      return images
    },

    openPropertyGallery(property, index) {
      this.selectedPropertyGallery = this.getPropertyGallery(property)
      this.selectedPropertyTitle = this.getPropertyGalleryTitle(property, index)
      this.selectedPropertyDescription = this.getPropertyGallerySummary(property)
      this.selectedPropertyPrice = property && property.from_price
        ? property.from_price
        : ''
      this.selectedPropertyGalleryKey =
        property.id ||
        property.uid ||
        `property-${index + 1}`
    },

    getPropertyGalleryTitle(property, index) {
      return `Property ${index + 1}`
    },

    getPropertyGallerySummary(property) {
      if (!property || !property.description) {
        return ''
      }

      return String(property.description).trim()
    },

    formatCurrency(value) {
      if (!value) {
        return ''
      }

      const numberValue = Number(String(value).replace(/[^0-9.-]+/g, ''))

      if (Number.isNaN(numberValue)) {
        return value
      }

      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        maximumFractionDigits: 0
      }).format(numberValue)
    },

    slugify(value) {
      if (!value) {
        return 'development'
      }

      return value
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
    },

    setPageMeta() {
      document.title = this.development.seo_meta || this.development.title || 'Luxury Development'

      const description = this.development.description || ''
      const image = this.getImageUrl(this.development.cover_image)

      this.setMetaTag('description', description)
      this.setMetaTag('keywords', this.development.seo_keywords || '')

      this.setOgTag('og:title', this.development.title || 'Luxury Development')
      this.setOgTag('og:description', description)
      this.setOgTag('og:image', image)
      this.setOgTag('og:url', window.location.href)
    },

    setMetaTag(name, content) {
      let tag = document.querySelector(`meta[name="${name}"]`)

      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('name', name)
        document.head.appendChild(tag)
      }

      tag.setAttribute('content', content)
    },

    setOgTag(property, content) {
      let tag = document.querySelector(`meta[property="${property}"]`)

      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('property', property)
        document.head.appendChild(tag)
      }

      tag.setAttribute('content', content)
    }
  }
}
</script>

<style scoped>
.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-left: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.2s linear infinite;
  margin-top: 80px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.banner-image {
  width: 100%;
  height: 520px;
  object-fit: cover;
}

.gallery-button {
  padding: 0;
  border: none;
  background: transparent;
  height: auto;
  text-decoration: underline;
  color: #255699;
}

.gallery-preview-btn {
  padding: 0;
  border: none;
  background: transparent;
  width: 100%;
}

.main-gallery-image {
  height: 470px;
  object-fit: cover;
}

.small-gallery-image {
  height: 231px;
  object-fit: cover;
}

.force-height {
  height: 300px;
  object-fit: cover;
}

.no-image {
  min-height: 300px;
  background: #efefef;
  position: relative;
}

.fixed-tags {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1000;
}

.offcanvas.offcanvas-bottom {
  height: 100vh;
  max-height: 100vh;
  top: 0;
}

.photo-album {
  margin: 0;
  padding: 0;
}

.photo-row {
  display: flex;
  margin: 0;
  padding: 0;
}

.photo-item {
  width: 100%;
  padding: 8px 14px;
}

.photo-item img {
  width: 100%;
  height: 620px;
  object-fit: cover;
  border-radius: 0;
}

.mini-detail {
  font-size: 20px;
  font-weight: bold;
}

.mini-detail span {
  display: block;
  font-size: 11px;
  font-weight: normal;
  text-transform: uppercase;
}

.property-gallery-button {
  min-width: 150px;
}

#propertyGalleryOffcanvas .offcanvas-header {
  border-bottom: 1px solid #e5e5e5;
}

#propertyGalleryOffcanvas .property-gallery-header {
  position: sticky;
  top: 0;
  z-index: 20;
  align-items: flex-start;
  gap: 24px;
  padding: 22px 34px 20px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 24px rgba(18, 48, 91, 0.08);
  backdrop-filter: blur(8px);
}

#propertyGalleryOffcanvas .property-gallery-heading {
  width: min(920px, calc(100% - 70px));
}

#propertyGalleryOffcanvas .property-gallery-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: #255699;
  font-family: Raleway-Bold, Arial, Helvetica, sans-serif;
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

#propertyGalleryOffcanvas .property-gallery-title {
  margin: 0;
  color: #12305b;
  font-family: Raleway-Bold, Arial, Helvetica, sans-serif;
  font-size: clamp(22px, 2.2vw, 34px);
  line-height: 1.15;
  text-transform: none;
  text-align: left;
}

#propertyGalleryOffcanvas .property-gallery-summary {
  max-width: 850px;
  margin: 8px 0 0;
  color: #4e5663;
  font-size: 14px;
  line-height: 1.55;
}

#propertyGalleryOffcanvas .property-gallery-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}

#propertyGalleryOffcanvas .property-gallery-price,
#propertyGalleryOffcanvas .property-gallery-count {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 31px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1;
}

#propertyGalleryOffcanvas .property-gallery-price {
  background: #12305b;
  color: #fff;
  font-family: Raleway-Bold, Arial, Helvetica, sans-serif;
}

#propertyGalleryOffcanvas .property-gallery-count {
  background: #e9eef5;
  color: #255699;
}

#propertyGalleryOffcanvas .property-gallery-close {
  flex: 0 0 auto;
  margin: 2px 0 0 auto;
}

#propertyGalleryOffcanvas .offcanvas-body {
  padding: 0;
}

#propertyGalleryOffcanvas .photo-row.large .photo-item {
  width: 50%;
}

#propertyGalleryOffcanvas .photo-row.small .photo-item {
  width: 33.333333%;
}

#propertyGalleryOffcanvas .photo-row.single {
  justify-content: center;
  background: #f5f5f5;
}

#propertyGalleryOffcanvas .photo-row.single .photo-item {
  width: 100%;
  max-width: 1320px;
  text-align: center;
}

#propertyGalleryOffcanvas .photo-item {
  padding: 0;
}

#propertyGalleryOffcanvas .photo-item img {
  display: block;
  width: 100%;
  border-radius: 0;
  object-fit: cover;
  padding: 14px;
}

#propertyGalleryOffcanvas .photo-row.large .photo-item img {
  height: 500px;
}

#propertyGalleryOffcanvas .photo-row.small .photo-item img {
  height: 420px;
}

#propertyGalleryOffcanvas .photo-row.single .photo-item img {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 78vh;
  margin: 0 auto;
  object-fit: contain;
}

@media (max-width: 991.98px) {
  .banner-image,
  .main-gallery-image,
  .small-gallery-image {
    height: 320px;
  }

  #propertyGalleryOffcanvas .property-gallery-header {
    padding: 16px 18px 15px;
  }

  #propertyGalleryOffcanvas .property-gallery-heading {
    width: calc(100% - 42px);
  }

  #propertyGalleryOffcanvas .property-gallery-title {
    font-size: 20px;
  }

  #propertyGalleryOffcanvas .property-gallery-summary {
    display: -webkit-box;
    overflow: hidden;
    font-size: 13px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  #propertyGalleryOffcanvas .property-gallery-meta {
    margin-top: 9px;
  }

  #propertyGalleryOffcanvas .photo-row {
    display: block;
  }

  #propertyGalleryOffcanvas .photo-row.large .photo-item,
  #propertyGalleryOffcanvas .photo-row.small .photo-item,
  #propertyGalleryOffcanvas .photo-row.single .photo-item {
    width: 100%;
  }

  #propertyGalleryOffcanvas .photo-row.large .photo-item img,
  #propertyGalleryOffcanvas .photo-row.small .photo-item img,
  #propertyGalleryOffcanvas .photo-row.single .photo-item img {
    height: 320px;
    padding: 8px 14px;
  }

  .fixed-tags {
    display: none;
  }
}

.property-card-gallery-trigger {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  overflow: hidden;
  cursor: pointer;
  text-align: left;
}

.property-card-gallery-trigger:focus-visible {
  outline: 3px solid #255699;
  outline-offset: 3px;
}

.property-card-gallery-trigger img {
  display: block;
  transition: transform 0.35s ease, filter 0.35s ease;
}

.property-card-gallery-overlay {
  position: absolute;
  left: 50%;
  bottom: 18px;
  transform: translateX(-50%) translateY(8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 150px;
  padding: 10px 18px;
  border-radius: 30px;
  background: rgba(18, 48, 91, 0.92);
  color: #fff;
  font-family: Raleway-Bold, Arial, Helvetica, sans-serif;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
}

.property-card-gallery-trigger:hover img,
.property-card-gallery-trigger:focus-visible img {
  transform: scale(1.035);
  filter: brightness(0.78);
}

.property-card-gallery-trigger:hover .property-card-gallery-overlay,
.property-card-gallery-trigger:focus-visible .property-card-gallery-overlay {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

@media (hover: none), (max-width: 767px) {
  .property-card-gallery-overlay {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
    bottom: 12px;
  }
}

</style>